"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectedCardTemplate = void 0;
const constants_1 = require("../../main/constants");
const CardTemplate_1 = require("../CardTemplate");
class SelectedCardTemplate extends CardTemplate_1.CardTemplate {
    constructor(id, moduleId, submoduleId, elementId, siblingId, cardQuestion, cardAnswer, gameplayInfo, conceptInfo, spacedRepInfo, selectedConceptMaterialId, diagram) {
        super(id, moduleId, submoduleId, elementId, siblingId, cardQuestion, cardAnswer, gameplayInfo, conceptInfo, spacedRepInfo, diagram);
        this.isSelected = true;
        this.isDuplicate = false;
        this.updatedDate = undefined;
        this.selectedConceptMaterialId = selectedConceptMaterialId;
    }
    static collectionPath() {
        throw new Error("Access SelectedCardTemplate.collectionPath() is incorrect behavior");
    }
    static customPlanCollectionPath(customPlanId) {
        // eslint-disable-next-line max-len
        return `${constants_1.constants.COLLECTION_PATH_CUSTOM_MODULE_PLAN}/${customPlanId}/${constants_1.constants.COLLECTION_PATH_SELECTED_CARD_TEMPLATE}`;
    }
}
exports.SelectedCardTemplate = SelectedCardTemplate;
SelectedCardTemplate.converter = {
    toFirestore(data) {
        var _a;
        const parent = CardTemplate_1.CardTemplate.converter.toFirestore(data);
        let child = {};
        if (data instanceof SelectedCardTemplate) {
            child = {
                selectedConceptMaterialId: data.selectedConceptMaterialId,
                updatedDate: data.updatedDate,
                isSelected: data.isSelected,
                isDuplicate: (_a = data.isDuplicate) !== null && _a !== void 0 ? _a : false
            };
        }
        return Object.assign(Object.assign({}, parent), child);
    },
    fromFirestore(snapshot) {
        var _a;
        const documentData = snapshot.data();
        const id = snapshot.id;
        const moduleId = documentData.moduleId;
        const submoduleId = documentData.submoduleId;
        const elementId = documentData.elementId;
        const siblingId = documentData.siblingId;
        const cardQuestion = documentData.cardQuestion;
        const cardAnswer = documentData.cardAnswer;
        const gameplayInfo = documentData.gameplayInfo;
        const conceptInfo = documentData.conceptInfo;
        const spacedRepInfo = documentData.spacedRepInfo;
        const selectedConceptMaterialId = documentData.selectedConceptMaterialId;
        const updatedDate = documentData.updatedDate;
        const isSelected = documentData.isSelected;
        const isDuplicate = (_a = documentData.isDuplicate) !== null && _a !== void 0 ? _a : false;
        const diagram = documentData.diagram;
        const data = new SelectedCardTemplate(id, moduleId, submoduleId, elementId, siblingId, cardQuestion, cardAnswer, gameplayInfo, conceptInfo, spacedRepInfo, selectedConceptMaterialId, diagram);
        data.updatedDate = updatedDate;
        data.isSelected = isSelected;
        data.isDuplicate = isDuplicate;
        return data;
    }
};
